import React from 'react';

import PropTypes from 'prop-types';

import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';
import TrackerCard from './trackerCard';

const AssetTracker = ({ hardwareList, tracker }) => {
  const {
    iotOrderDetailsSection: { labelAssetTracker }
  } = useLocalizedStringsContext();

  const {
    assetTrackerRateplanTotal,
    additionalServicesTotal,
    addonsTotal,
    vehiclesTotal
  } = tracker;
  const props = {
    title: labelAssetTracker,
    hardwareList,
    rateplanTotal: assetTrackerRateplanTotal,
    ...(additionalServicesTotal && { additionalServicesTotal }),
    addonsTotal,
    vehiclesTotal
  };
  return <TrackerCard {...props} />;
};

AssetTracker.propTypes = {
  hardwareList: PropTypes.objectOf(PropTypes.any).isRequired,
  tracker: PropTypes.shape({
    fleetTrackerRateplanTotal: PropTypes.number,
    assetTrackerRateplanTotal: PropTypes.number,
    additionalServicesTotal: PropTypes.number,
    addonsTotal: PropTypes.number,
    vehiclesTotal: PropTypes.number
  }).isRequired
};

export default AssetTracker;
